import { render, staticRenderFns } from "./Warehouse_detail.vue?vue&type=template&id=2a35ae58&scoped=true&"
import script from "./Warehouse_detail.vue?vue&type=script&lang=js&"
export * from "./Warehouse_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a35ae58",
  null
  
)

export default component.exports